export default __webpack_public_path__ + "static/media/gifbtn.5b114a5e.svg";